module.exports = __webpack_public_path__ + "img/lock.25ae3a48.svg";